import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {ErrorBoundary, ErrorBoundaryProps} from "@sentry/react";

export const UpErrorBoundary = ({children, ...rest}: ErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={ErrorFallback} {...rest}>
      {children}
    </ErrorBoundary>
  );
};
